<template>
<div id="it1024im">
  <!-- 头部组件 -->
  <component :is="header_"></component>
    
  <div class="it1024im">
    <!--  -->
    <el-container style="border: 1px solid #eee">
      <!-- 侧栏组件 -->
      <component :is="celan"></component>
      
      <!-- 主体 -->
      <el-main>

      <div :class="{enlarge:flag}" class="container-box">
      <!-- 侧栏组件2  style="width: 31%"-->
      <el-aside class="el-aside-box" style="width: 200px">
          <!-- <div>沟通记录</div> -->
          <ul style="height: 100%;">
            <div v-for="(it1024im_,idx) in it1024im_id">
             <div v-for="number in userid_number">
              <div v-if="number.userid==it1024im_?true:false">
               <li @click="GetUserid(idx,it1024im_)" :class="{ ListClass:idx==ListId}">
                 <img :src="it1024imURL+'/php/upimg/it1024im-fangkeimg.png'">
                 <span>
                    &nbsp;访客
                   <!-- ({{it1024im_}}) -->
                 </span>
                 <span v-if="number.userid==it1024im_?true:false" class="it1024im-Unread-messages">
                   <span v-if="number.userid_number=='0'?false:true">
                     {{number.userid_number}}
                   </span>
                 </span>
               </li> 
              </div>          
             </div>          
            </div>          
          </ul>
      </el-aside>
   
      <div id="container_">
        <div class='it1024im-window-title' @mousedown="MoveChat">
           
           <span>在线咨询</span>
           <ul class="it1024im-box-min">
             <li @click="ChatHide"></li>
             <li @click="enlarge"></li>
             <li @click="ChatHide"></li>
           </ul>
        </div>
        <div id="container_val">
          <div v-for="it1024im_ in it1024im">
           <!-- 游客 -->
           <div v-if="it1024im_.type=='fangke'?true:false" class="fangke" style="clear:both;float: left;position: relative;">
              <p style="float:right;">
                <span style="color:#999;font-size:13px;margin-bottom:5px;display:block;float:left;margin-left: 10px;">
                   访客&nbsp;&nbsp;{{it1024im_.time}}
                </span>
                <span class="fangkeval" v-html="it1024im_.content">
                    <!-- {{it1024im_.content}} -->
                </span>
              </p>
                <img style="width:39px;float:left;margin-top:19px;margin-right: 10px;border-radius: 50%;" :src="it1024imURL+'/php/upimg/it1024im-fangkeimg.png'">
           </div>
           <!-- 客服 -->
           <div v-if="it1024im_.type=='kefu'?true:false" class="myhuifu" style="clear:both;float: right;position: relative;">
              <p style="float:left;">
                 <span style="color:#999;font-size:13px;margin-bottom:5px;display:block;float:right;margin-right: 10px;">
                    {{it1024im_.time}}&nbsp;&nbsp;客服
                 </span>
                 <span class="kefuval" v-html="it1024im_.content">>
                     <!-- {{it1024im_.content}} -->
                 </span>
              </p>
              <img style="width:39px;float:right;margin-top:19px;margin-left: 10px;border-radius: 50%;" :src="it1024imURL+'/php/upimg/it1024im-kefuimg.png'">
           </div>
          </div>
        </div>
        <div class="it1024im-textarea-box">
          <textarea v-model="textarea_val" @keyup.enter="btn()" style="resize:none;outline:none;padding: 4px 4px 0px;" rows="3" cols="20" class="it1024im-window-textarea" placeholder="" /></textarea>
          <input @click="btn" type="button" class="it1024im-window-button" value="发送" />
        </div>
      </div>
      </div>
        
      </el-main>

    </el-container>
  </div>

</div>
</template>

<script>
//全局属性
import global from '@/common/common.vue'
//头部组件
import header_ from './header_.vue'    
import celan from './celan.vue'    
export default {
    name: 'it1024im',
    data() {
      return {
        header_: header_,
        celan: celan,
        textarea_val: '',
        it1024im:[],
        it1024im_id:[],
        userid_number:[],
        ImUserid:'',
        positionX:0,
        positionY:0,
        flag:false,
        ListId:'',
        numberSum:0,
        it1024imURL: global.it1024imURL,
        posturl: global.it1024imUrl,
      }
    },
    methods: {
       btn(){
          
          if(this.textarea_val.replace(/^\s+$/g,"") == ''){
             this.$notify({
                title: '提示',
                message: '请输入内容',
                type: 'warning'
             });
          }else{ 
            //时间
            var newDate_ = new Date();
            var time_ = newDate_.getFullYear() + '-' + (newDate_.getMonth() + 1) + '-' + newDate_.getDate() + ' ' + newDate_.getHours() + ':' + newDate_.getMinutes() + ':' + newDate_.getSeconds();

            var ImUserid = localStorage.getItem("ImUserid"); //取

            //使用正则替换<>'
            var replace1 = this.textarea_val.replace(/</g,"&lt;");
            var replace2 = replace1.replace(/>/g,"&gt;");
            this.textarea_val = replace2.replace(/'/g,"’");

            //data
            var objim = {
                avatar: "",
                content: this.textarea_val,
                userid: ImUserid,
                state: false,
                time: time_,
                type: "kefu",
                username: "客服"
              };
            
              this.it1024im.push(objim);
              //让滚动条一直处于聊天窗口底部
              this.$nextTick(function () {
                  var container_val = document.getElementById('container_val');
                  container_val.scrollTop = container_val.scrollHeight;
              });
              //发送完成后清空输入框
              this.textarea_val = '';
              //提交数据
              this.$http.post(this.posturl,{objim:objim},{emulateJSON:true}).then(res=>{
                    if(res.body){
                        // console.log(res.body);
                        this.it1024im.push(res.body);
                    }else{
                        //提示消息
                        this.$notify.error({
                          title: '提示',
                          message: '信息发送失败'
                        });
                    }
              });

          };
       },
       //点击选择聊天对象，设置已读
       GetUserid(idx,id){
           localStorage.setItem("It1024imDataLengths",'');
           // console.log(idx)
           this.ListId=idx;
           localStorage.setItem("ListId",idx); 
           localStorage.setItem("ImUserid",id); 
           this.ImUserid = id;
           //提交已读ID，获取点击对象的聊天记录
           this.$http.post(this.posturl,{userid:id,ReadId:id},{emulateJSON:true}).then(res=>{
               this.it1024im=res.body;
               //让滚动条一直处于聊天窗口底部
               this.$nextTick(function () {
                 var container_val = document.getElementById('container_val');
                 container_val.scrollTop = container_val.scrollHeight;
               });
           });
       },
       //拖拽聊天界面
       MoveChat(e){
            var chatbox = e.path[2];//获取目标元素
            // console.log(e.path[2])
            //算出鼠标相对元素的位置
            var disX = e.clientX - chatbox.offsetLeft;
            var disY = e.clientY - chatbox.offsetTop;
            document.onmousemove = (e)=>{ //鼠标按下并移动的事件
                //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                var left = e.clientX - disX;    
                var top = e.clientY - disY;
                
                //绑定元素位置到positionX和positionY上面
                this.positionX = top;
                this.positionY = left;
                
                //移动当前元素
                chatbox.style.left = left + 'px';
                chatbox.style.top = top + 'px';
            };
            document.onmouseup = (e) => {
                document.onmousemove = null;
                document.onmouseup = null;
            };
       },
       //放大聊天窗口
       enlarge(e){
           this.flag = !this.flag;
           //聊天窗口放大居中
           var chatbox = e.path[4];
           chatbox.style.left = '50%';
           chatbox.style.top = '50%';
       },
       ChatHide(e){
          //关闭聊天窗口
          var chatbox = e.path[4];
          chatbox.style.display = 'none';
       }           
    },
    mounted() {
      //获取选择的联系人
      var ListId = localStorage.getItem("ListId"); 
      if(ListId != null){
         this.ListId=ListId;
      }; 

      localStorage.setItem("numberSum2",'');
      //id存在请求聊天数据 
      setInterval(()=>{
        var ImUserid = localStorage.getItem("ImUserid"); 
          if(ImUserid != null){//选择的用户存在继续获取聊天记录
            this.$http.post(this.posturl,{userid:ImUserid,ReadId:ImUserid},{emulateJSON:true}).then(res=>{
               this.it1024im=res.body;

               var It1024imDataLengths = localStorage.getItem("It1024imDataLengths");//存数据的总数
               if (res.body.length > It1024imDataLengths) {
                localStorage.setItem("It1024imDataLengths",res.body.length); 
                   //让滚动条一直处于聊天窗口底部
                   this.$nextTick(function () {
                     var container_val = document.getElementById('container_val');
                     container_val.scrollTop = container_val.scrollHeight;
                   });
               };     

            });
           };  
           this.$http.post(this.posturl,{userid_:true},{emulateJSON:true}).then(res=>{
               //获取所有用户ID
               this.it1024im_id=res.body[0];
               //获取未读数量
               this.userid_number=res.body[1];

               //收到信息提示声音
               var numberArr=res.body[1];
               var numberSum=0;
               for (var key in numberArr) {
                   if (numberArr[key].userid_number != '0') {
                      //未读总数
                      numberSum+=parseInt(numberArr[key].userid_number);
                      this.numberSum=parseInt(numberArr[key].userid_number);
                   }
               };
               var numberSum2 = localStorage.getItem("numberSum2");
               if (numberSum > numberSum2) {
                   var audio= new Audio(""+this.it1024imURL+"/assets/im.mp3");
                   audio.play();
                   localStorage.setItem("numberSum2",numberSum);
               }else{
                   localStorage.setItem("numberSum2",numberSum);
               };


           });
         
      },1000);
     
      //判断浏览器当前窗口宽度进入电脑端还是手机端 
      if(window.screen.width <= 800){
        this.$router.push({path:'/mobile'})
      };

    }
  }
</script>


<style scoped>
section{
  height: 100vh;
}

.it1024im{
    background: white;
}

.celan {
    height:100%;
}

.el-aside {
    height: 100%;
    background-color: #f3f3f3;
    color: #333;
    display: inline-block;
}

/*隐藏滚动条*/
::-webkit-scrollbar {
  display: none; /* Chrome Safari */
};
scrollbar-width: none; /* firefox */
-ms-overflow-style: none; /* IE 10+ */
overflow-x: hidden;
overflow-y: auto;


ul,ul li{
  list-style-type: none
}

.el-aside-box ul li {
    padding: 7px;
/*    background: #efefef;*/
    margin: 2px;
    border-radius: 3px;
    cursor: pointer;
}
.el-aside-box ul li img{
    vertical-align: middle;
    border-style: none;
    width: 38px;
    border-radius: 50%;
}

.it1024im-Unread-messages {
    background: #ff4444;
    color: #fff;
    font-size: 12px;
    border-radius: 53%;
    margin-left: 4rem;
    width: 1.5rem;
    display: inline-block;
    text-align: center;
    overflow: hidden;
}

.container-box{
    width: 750px;
    height: 522px;
    box-shadow: 0px 3px 29px 0px rgb(173, 173, 173);
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
    display: flex;
    justify-content: space-around;
    text-align: center;
}

.el-main {
  padding: 0px;
  background-color: #E9EEF3;
  color: #333;
}

#container_ {
    width: 100%;
    height: 100%;
    background: white;
    overflow: hidden;
    display: inline-block;
}

#container_val {
    background: whitesmoke;
    padding-top: 25px;
    padding: 0px 6px 0px 6px;
    height: 65.5%;
    overflow: auto;
}

.myhuifu, .fangke {
    padding-bottom: 1rem;
    padding-top: 1rem;
}
.kefuval{
  display:block;
  word-break: break-all;
  clear: both;
  background:#6793e0;
  padding:8px 15px;
  border-radius: 5px;
  color: white;
  max-width: 423px;
  margin-right: 8px;
  float: right;
  text-align: left;
}
.fangkeval{
  display:block;
  word-break: break-all;
  clear: both;
  background:#009688;
  padding:8px 15px;
  border-radius: 5px;
  color: white;
  max-width: 423px;
  margin-left: 8px;
  float: left;
  text-align: left;
}
.fangkeval:after {
    content: '';
    position: absolute;
    top: 55px;
    left: 47px;
    width: 0;
    height: 0;
    border-style: solid dashed dashed;
    border-color: #009688 transparent transparent;
    overflow: hidden;
    border-width: 10px;
}
.kefuval:after {
    content: '';
    position: absolute;
    top: 55px;
    right: 47px;
    width: 0;
    height: 0;
    border-style: solid dashed dashed;
    border-color: #6793e0 transparent transparent;
    overflow: hidden;
    border-width: 10px;
}
.it1024im-textarea-box {
    display: flex;
    justify-content: space-around;
    text-align: center;
}
.it1024im-window-textarea {
    width: 100%;
    height: 104px;
    border: none;
}

.it1024im-window-button {
    margin-right: 3px;
    padding: 0 11px;
    background-color: #009688;
    color: #fff;
    border-radius: 3px;
    border: none;
    margin-top: 35px;
    display: inline-block;
    height: 37px;
}

.it1024im-window-title {
    background: #6793e0;
    line-height: 75px;
    font-size: 21px;
    font-weight: bold;
    color: #ffffff;
    padding-left: 8px;
    cursor: move;
    width: 100%;
    height: 75px;
}
.it1024im-window-title span{
   float: left;
}

.it1024im-box-min {
    position: absolute;
    right: 8px;
    top: 11px;
    cursor: pointer;
}
.it1024im-box-min li{
    float: left;
    width: 16px;
    margin: 5px;
    height: 16px;
    list-style-type: none;
}
.it1024im-box-min li:nth-child(1){
    width: 15px;
    height: 2px;
    background-color: #000000;
    cursor: pointer;
    margin-top: 13px;
}
.it1024im-box-min li:nth-child(2){
   background: url(./../../static/icon.png) no-repeat;
  background-position: -31px -39px;
}
.it1024im-box-min li:nth-child(3){
   background: url(./../../static/icon.png) no-repeat;
   background-position: 1px -39px;
}

.ListClass{
   background: #e6e6e6 !important;
}

/*放大聊天窗口*/
.enlarge{
    width: 100%;
    height: 100%;
/*    top: 0px !important;
    left: 0px !important;*/
}

</style>


// WEBPACK FOOTER //
// src/components/it1024im.vue